import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import AllPackagedServices from "./AllPackagedServices/AllPackagedServices";
import FilterAll from "../FilterAll/FilterAll";
import { useDispatch, useSelector } from "react-redux";
import { getFilter } from "../../../../redux/filter/action";
import OTSSearch from "../../../Common/Search/OTSSearch";
import classnames from "classnames";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { FilterOTSListings } from "../../../../redux/ots/action";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { getPostStingName } from "../../../../assests/extention/commonfunction";

export default function SearchPackaged() {
  const { state, setSearch } = useAllFilterBaseContext();
  const path = "Assets/scss/FindWork.module.scss";

  const {
    setProposed,
    setViewed,
    setWishlist,
    setListNull,
    setRerender,
    setAllpostfiltertab,
  } = useAllFilterBaseContext();
  const dispatch = useDispatch();
  const { pageNumber } = state;
  const size = 15;

  const [activeTab, setActiveTab] = useState(
    "allpost" || state?.allpostfiltertab
  );

  useEffect(() => {
    if (state?.allpostfiltertab) {
      setActiveTab(state?.allpostfiltertab);
    } else {
      setActiveTab("allpost");
    }
  }, [state?.allpostfiltertab]);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getFilter(3));
  }, []);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setAllpostfiltertab(tab);
      setRerender();

      switch (tab) {
        case "allpost":
          setListNull();
          break;
        case "recentview":
          setViewed();
          break;
        case "savepost":
          setWishlist();
          break;
        case "appliedpost":
          setProposed();
          break;
        default:
          break;
      }
    }
  };

  const getpostlist = useSelector(
    ({ ots: { getfilterdots } }) => getfilterdots
  );

  const data = {
    method: "GET",
    index: pageNumber,
    size: size,
    search: state?.search,
    proposed: state?.proposed,
    viewed: state?.viewed,
    wishlist: state?.wishlist,
    filter: [
      {
        id: "49",
        title: "Category",
        filter_type: "5",
        values: state?.keywords,
      },
      {
        id: "19",
        title: "sort by",
        filter_type: "2",
        values: state?.sortByTimeBxp,
      },
      {
        id: "20",
        title: "Industry",
        filter_type: "5",
        values: state?.industries,
      },
      {
        id: "21",
        title: "Search",
        filter_type: "6",
        values: state?.search,
      },
      {
        id: "22",
        title: "Price range",
        min: state?.minHourlyRate,
        max: state?.maxHourlyRate,
        filter_type: "7",
      },
    ],
  };

  useEffect(() => {
    dispatch(FilterOTSListings(data));
    window.scrollTo({
      top: 600,
      behavior: "smooth",
    });
  }, [state]);


  const { setOTSroute } = useRouteBaseStateContext();
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");


  return (
    <div className="project-section">
      <div className="col-md-12 project1">
        <div className="col-md-5 mx-auto">
          <h2 className="font-42">
            Kickstart your project with packaged services.
          </h2>
          <OTSSearch
            state={state}
            setSearch={setSearch}
            placeholder={`Search ${getPostStingName("4")}`}
          />
        </div>
        <p>Have a product for packaged services? Let’s get it listed</p>
        <button
          onClick={() => { navigate(`/${lan}/dashboard/myotsproducts`); setOTSroute('Packageservice'); }}
          className="btn post-btn"
        >
          Add OTS
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/project/plus.svg`}
            alt=""
          />
        </button>
      </div>
      <div className="col-lg-10 mx-auto tab-sec packaged-tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "allpost" })}
              onClick={() => {
                toggle("allpost");
              }}
            >
              All ({getpostlist?.count?.count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "recentview" })}
              onClick={() => {
                toggle("recentview");
              }}
            >
              Recently viewed ({getpostlist?.count?.viewed_count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "savepost" })}
              onClick={() => {
                toggle("savepost");
              }}
            >
              Saved package ({getpostlist?.count?.wishlist_count || 0})
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="allpost">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <FilterAll />
              </div>
              {activeTab == "allpost" && (
                <AllPackagedServices data={data} activeTab={activeTab} />
              )}
            </div>
          </TabPane>
          <TabPane tabId="recentview">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <FilterAll />
              </div>
              {activeTab == "recentview" && (
                <AllPackagedServices data={data} activeTab={activeTab} />
              )}
            </div>
          </TabPane>
          <TabPane tabId="savepost">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <FilterAll />
              </div>
              {activeTab == "savepost" && (
                <AllPackagedServices data={data} activeTab={activeTab} />
              )}
            </div>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
}
